module.exports = __webpack_public_path__ + "38bb225c8bee17e4ec55856d8efff5ab.pdf";